// extracted by mini-css-extract-plugin
module.exports = {"root":"user-reviews_root__y8Rf_","list":"user-reviews_list__B1XAf","btn":"user-reviews_btn__i8PPO"};